import qs from 'qs';
import { Config } from '@packages/shared/interfaces';
import { YEAR_IN_DAYS } from '@packages/shared/core/common/constants';
import { UtmTags } from '@packages/shared/core/user/entities';
import { isValidUuid } from '@packages/shared/core/common/utils/string';
import { UTM_TAGS_COOKIE_LIFETIME_IN_DAYS } from '@packages/shared/core/user/constants';
import { CookiesService } from '../cookies';

export class CrossDomainStorage {
  private readonly config: Config;

  private readonly cookies: CookiesService;

  private readonly splitIdCookieKey = 'split_id';

  constructor(config: Config) {
    this.config = config;

    this.cookies = new CookiesService({
      domain: config.domainRoot,
    });
  }

  isOptOutSellUserData() {
    return !!this.cookies.get('doNotSellMyData');
  }

  isTestingTokenPresent() {
    const token = this.cookies.get(this.config.testingTokenCookieKey) || '';

    return isValidUuid(token);
  }

  optOutSellUserData() {
    this.cookies.set('doNotSellMyData', 'true', { expires: YEAR_IN_DAYS });
  }

  saveUtmTags(utmTags: UtmTags) {
    const stringifiedTags = JSON.stringify(utmTags);

    this.cookies.set('nebula_utm_tags', stringifiedTags, {
      expires: UTM_TAGS_COOKIE_LIFETIME_IN_DAYS,
    });
  }

  getUtmTags(): UtmTags {
    const rawUtmTags = this.cookies.get('nebula_utm_tags');
    return rawUtmTags ? JSON.parse(rawUtmTags) : {};
  }

  async saveLastUserEmail(email: string) {
    const key = 'nebula_last_email';
    await this.cookies.set(key, email, {
      expires: YEAR_IN_DAYS,
    });
  }

  async getLastUserEmail() {
    const key = 'nebula_last_email';
    return this.cookies.get(key) || '';
  }

  setNebulaId(value: number) {
    this.cookies.set('nebula_id', value.toString(), { expires: YEAR_IN_DAYS });
  }

  getNebulaId(): string | undefined {
    const value = this.cookies.get('nebula_id');

    return value && value.length > 0 ? value : undefined;
  }

  loadSplitIdFromQueryParams() {
    const { split_id: snakeCaseSplitId, splitId } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    const rawSplitId = snakeCaseSplitId || splitId;
    const splitIdFromUrl = Array.isArray(rawSplitId) ? rawSplitId[0] : rawSplitId;

    if (typeof splitIdFromUrl !== 'string' || !isValidUuid(splitIdFromUrl)) return;

    this.cookies.set(this.splitIdCookieKey, splitIdFromUrl, { expires: YEAR_IN_DAYS });
  }
}
